
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"clip-rule":"evenodd","d":"M17.707 7.768a1 1 0 00-1.414-1.415L12 10.646 7.707 6.353a1 1 0 00-1.414 1.415l4.293 4.292-4.293 4.293a1 1 0 001.414 1.415L12 13.475l4.293 4.293a1 1 0 001.414-1.415l-4.293-4.293 4.293-4.292z"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      